<template>
  <div class="search clearfix">
    <div class="msg">
      <!-- <i class="el-icon-search icon" @click="show = !show"></i> -->
      <div v-show="searchFlag" class="nav-item">
        <a href="javascript:void(0)" @click.prevent.stop="showLogin">登录</a><span class="separate">|</span><a href="#" @click.prevent.stop="showReg">注册</a>
      </div>
       <!--<router-link v-show="!searchFlag" class="nav-item" to="/UserCenter" target="_blank" >个人中心</router-link>-->
      <el-dropdown v-show="!searchFlag" @command="handleCommand">
        <span class="el-dropdown-link nav-item" style="font-size: 16px;" @click="handleClick">个人中心</span>
        <el-dropdown-menu slot="dropdown" >
          <el-dropdown-item command="handgtgl" v-show="htglFlag">管理后台</el-dropdown-item>
          <el-dropdown-item command="handloder">我的订单</el-dropdown-item>
          <el-dropdown-item command="handlcurse">我的课程</el-dropdown-item>
          <el-dropdown-item command="handlmess">消息中心</el-dropdown-item>
          <el-dropdown-item command="handlstudy">学习兴趣</el-dropdown-item>
          <el-dropdown-item command="handlauth">我的认证</el-dropdown-item>
          <el-dropdown-item command="handltest">证书查询</el-dropdown-item>
          <el-dropdown-item command="handldata">个人资料</el-dropdown-item>
          <el-dropdown-item command="handllayout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
       <!--<div  v-show="!searchFlag" class="nav-item" style="cursor: pointer" @click="showReg">个人中心</div>-->
    </div>
    
     <!-- <transition name="move">
       <input type="text" placeholder="请输入相关课程内容" v-show="show">
     </transition> -->
    <!-- <input type="text" placeholder="请输入内容并按Enter" :class="{'active': show === true}" v-model="listcourseQuery.name"  @keyup.enter="handleFilter2" > -->
    <div class="search-input-wrapper">
      <el-input 
        @focus="handleFocus" 
        @blur="!enterFlag?searchListFlag = false:blurFlag=true" 
        placeholder="请输入您想要查找的内容" 
        v-model="listcourseQuery.name" 
        @keyup.enter.native="handleFilter2"
        class="input-with-select">
        <el-select v-model="listcourseQuery.searchMark" slot="prepend" placeholder="请选择">
          <el-option label="课程" value="1"></el-option>
          <el-option label="机构" value="2"></el-option>
        </el-select>
        <el-button 
          slot="append" 
          @click="handleFilter2"
          icon="el-icon-search">
        </el-button>
      </el-input>
    </div>

    <transition name="display">
      <div class="search-list" v-if="searchListFlag" @mouseover="enterFlag = true" @mouseleave="blurFlag?searchListFlag = false:enterFlag = false">
        <span class="clear" @click="handleClear" :class="histroyList.length===0?'invalid':''"><i class="el-icon-delete"></i>清空</span>
        <div class="title" v-if="histroyList.length>0">历史搜索</div>
        <ul class="histroy">
          <li v-for="(item, index) in histroyList" :key="index">
            <span @click="handleItem(item)">
              {{item}}
            </span>
          </li>
        </ul>
        <div class="title">热门搜索</div>
        <ul class="hot">
          <li v-for="item in hotList" :key="item.id">
            <span @click="handleItem(item.name)">
              {{item.name}}
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>

// import LoginRegister from '@/views/components/login-register/index.vue'
import { fetchCourseType, getCourse } from '@/api/course.js'
import { fetchHotTag } from '@/api/tag.js'
import {logout} from '@/api/user-center/getUser'
import { getToken, removeToken } from '@/common/js/auth.js'
import { fetchBusinessApply, fetchPersonApply, loginht } from '@/api/recruit'
import storage from 'good-storage'
import { mapGetters } from 'vuex'

let timer;
const HISTROYLIST = '__histroyList__'
export default {
  data () {
    return {
      show: false,
      searchFlag: true,
      searchListFlag: false,
      maskShow: false,
      enterFlag: false, // 进入搜索列表的标记
      blurFlag: false, // 输入框失去焦点的标记
      listcourseQuery: {
        name: '',
        searchMark: this.$route.query.searchMark || '1' // 搜索选择类型 1课程 2机构
      },
      histroyList: [],
      hotList: [],

      Status: '',
      StepStatus: '',
      grStatus: '',
      grStepStatus: '',
      htglFlag: false,
      list: null,
      list1: null,
      authcode: '',
    }
  },
  computed: {
    ...mapGetters(['userId', 'searchMark'])
  },
  created () {
    this.getHotTag();
    if (getToken()) {
      this.searchFlag = false
      this.getinfo()
      this.getqyinfo()
    }
  },
  mounted () {
  },
  methods: {
    // 查个人信息
    getinfo () {
      fetchPersonApply().then(res => {
        this.list = res.data
        this.grStatus = this.list.approveStatus
        this.grStepStatus = this.list.applyStep
        if (this.grStepStatus === 'OVER' && this.grStatus === 1) {
          this.htglFlag = true
        }
      })
    },
    // 查企业信息
    getqyinfo () {
      fetchBusinessApply().then(res => {
        this.list1 = res.data
        this.Status = this.list1.approveStatus
        this.StepStatus = this.list1.applyStep
        if (this.StepStatus === 'OVER' && this.Status === 1) {
          this.htglFlag = true
        }
      })
    },
    getHotTag () {
      let obj = {
        pageNo: 1,
        pageSize: 5,
        status: 1
      }
      fetchHotTag(obj).then(res => {
        this.hotList = res.data.rows;
      })
    },
    // item被点击
    handleItem (name) {
      this.listcourseQuery.name = name;
      this.handleFilter2();
    },
    // 清空历史列表
    handleClear () {
      storage.remove(HISTROYLIST);
      this.histroyList = [];
    },
    handleFocus () {
      this.histroyList = storage.get(HISTROYLIST) || [];
      setTimeout(() => {
        this.searchListFlag = true;
      }, 20)
      
      this.blurFlag = false;
      this.enterFlag = false;
    },
    init () {
      this.histroyList = storage.get(HISTROYLIST) || [];
    },
    showLogin () {
      let obj = {
        from: this.$route.path,
        type: 'login',
        ...this.$route.query
      }
      this.$router.push({path: '/Login', query: obj})
    },
    showReg () {
      let obj = {
        from: this.$route.path,
        type: 'register',
        ...this.$route.query
      }
      this.$router.push({path: '/Login', query: obj})
    },
    handleFilter2() {
      if (!this.listcourseQuery.name.trim()) {
        this.$message({
          message: '搜索内容不能为空或者空格',
          type: 'warning'
        });
        return
      }
      let newName = this.listcourseQuery.name.replace(/[ ]/g,"")
      if (!this.histroyList.includes(newName)) {
        this.histroyList.unshift(newName);

        // 最多只要5个
        this.histroyList.splice(5);
        // 将历史搜索信息保存到记录里面
        storage.set(HISTROYLIST, this.histroyList);
      }

      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        this.$router.push({path: '/searchcourse', query: this.listcourseQuery})
      }, 300)
    },
    handleClick() {
      let routeData = this.$router.resolve({path: '/UserCenter'})
      window.open(routeData.href, '_blank')
    },
    //点击改变菜单
    handleCommand(command) {
      if (command === 'handgtgl') {
        loginht().then(res => {
          try {
            this.authcode = res.data
            // debugger
            window.location.href = process.env.BASE_HT + '?authcode=' + this.authcode
          } catch (err) {
            console.log(err);
          }
          // console.log(process.env);
          // // process.env.BASE_HT
          // console.log(this.authcode)
          //  // let routeData = this.$router.resolve({ path: 'www.baidu.com', query: {authcode: this.authcode} })
          // console.log(process.env.BASE_HT)
          //  // window.open('www.baidu.com', '_self')
          //
        })
      }else if (command === 'handloder') {
        let routeData = this.$router.resolve({path: '/UserCenter/MyOrder'})
        window.open(routeData.href, '_self')
      }else if (command === 'handlcurse'){
        let routeData = this.$router.resolve({path: '/UserCenter/MyCourse'})
        window.open(routeData.href, '_self')
      }else if (command === 'handlmess'){
        let routeData = this.$router.resolve({path: '/UserCenter/MyMess'})
        window.open(routeData.href, '_self')
      }else if (command === 'handlstudy'){
        let routeData = this.$router.resolve({path: '/UserCenter/MyStudy'})
        window.open(routeData.href, '_self')
      }else if (command === 'handlauth'){
        let routeData = this.$router.resolve({path: '/UserCenter/MyAuth'})
        window.open(routeData.href, '_self')
      } else if (command === 'handltest'){
        let routeData = this.$router.resolve({path: '/UserCenter/MyCert'})
        window.open(routeData.href, '_self')
      }else if (command === 'handldata'){
        let routeData = this.$router.resolve({path: '/UserCenter/MyData'})
        window.open(routeData.href, '_self')
      }else if (command === 'handllayout'){
        this.$confirm('此操作将退出登录, 是否继续?', '提示', {
          confirmButtonText: "确定",
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          logout(getToken()).then(res => {
            this.$message({
              message: '退出登录',
              type: 'success'
            });
            removeToken()
            storage.clear()
            let uri = window.location.href;
            let params = uri.split('?');
            let indexurl = params[0];
            console.log(indexurl)
            let canshu=this.$route.query
            console.log(canshu)
            if ( canshu !=null && uri.indexOf('code')<0 ){
              this.$router.push('/');
              location.reload();
            } else {
              window.location.href = indexurl
            }
            // this.$router.push(indexurl);
            // window.open(indexurl, '_self')
            // window.location.href = 'https://www.baidu.com/';
            // window.open(indexurl, '_blank')
            // console.log('这儿是退出登录')
            // location.reload();
            // let routeData = this.$router.resolve({path: indexurl})
            // window.open(routeData.href, '')
          });
        });
      }
    },
  },
  watch: {
    userId (val) {
      if (val) {
        this.searchFlag = false
        this.getinfo()
        this.getqyinfo()
      }
    },
    searchMark (val) {
      this.listcourseQuery.searchMark = val;
    },
    '$route': function (to, from) {
      this.searchListFlag = false;
      // console.log('to', to);
      if (to.path === '/') {
        // this.searchListFlag = false;
        this.listcourseQuery.name = '';
      }
　　},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
 @import '~@/styles/base.scss';
  .search {
    position: relative;
    font-size: 16px;
    line-height: 21px;
    color: #4D555D;
    input {
      position: absolute;
      margin-left: 20px;
      left: 0;
      top: 0;
      width: 193px;
      display: block;
      box-sizing: border-box;
      border-left: solid 1px #bbb;
      border-right: solid 1px #bbb;
      padding: 0 20px;
      margin-right: 10px;
      line-height: 21px;
      font-size: 14px;
      -webkit-transition: all .2s;
      transform: translate3d(100px, 0, 0);
      /*transform: translate3d(193px, 0, 0);*/
      opacity: 0;
      /*transform: translate3d(100%, 0, 0);*/
      &.active {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }
      background-color: rgba(0, 0, 0, 0);
    }
    input::-webkit-input-placeholder{ /*WebKit browsers*/
      font-size: 12px;
      color: #bbb;
    }
    input::-moz-input-placeholder{ /*Mozilla Firefox*/
      font-size: 12px;
      color: #bbb;
    }
    input::-ms-input-placeholder{ /*Internet Explorer*/
      font-size: 12px;
      color: #bbb;
    }
    .msg {
      position: absolute;
      z-index: 1;
      right: 0;
      top: 0;
      .icon {
        margin-right: 20px;
        cursor: pointer;
      }
      .separate {
        margin: 0 20px;
        font-size: 12px;
      }
      .nav-item {
        display: inline-block;
        cursor: pointer;
      }
    }
    a:hover {
      color: #7AA7FF;
    }
    .search-input-wrapper {
      display: inline-block;
      width: 330px;
      position: absolute;
      right: 135px;
      top: -7px;
    }
    .search-list {
      position: absolute;
      top: 30px;
      right: 135px;
      z-index: 100;
      width: 330px;
      border: solid 1px #dddddd;
      box-shadow: 0 2px 2px rgba(77, 85, 93, .4);
      font-size: 12px;
      background-color: #fff;
      .title, li {
        padding-left: 15px;
        height: 32px;
        line-height: 32px;
        color: #999;
      }
      li {
        cursor: pointer;
        color: #444;
        padding: 0 30px;
        span {
          display: inline-block;
          width: 270px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        &:hover {
          background-color: #81A3EB;
        }
      }
      .clear {
        position: absolute;
        cursor: pointer;
        right: 5px;
        top: 5px;
        color: #999;
      }
      .invalid {
        color: #ccc;
        cursor: not-allowed;
      }
    }

    .display-enter,
    .display-leave-to {
      opacity: 0;
    }
    .display-enter-active,
    .display-leave-active {
      transition: all .5s;
    }
    .display-enter-to,
    .display-leave {
      opacity: 1;
    }
  }
</style>
<!--<style>-->
  <!--.el-dropdown-menu&#45;&#45;medium .el-dropdown-menu__item {-->
    <!--line-height: 40px;-->
    <!--padding: 4px 17px;-->
    <!--font-size: 14px;-->
  <!--}-->
  <!--.el-dropdown-menu__item:not(.is-disabled):hover, .el-dropdown-menu__item:focus {-->
    <!--background-color: #fff !important;-->
    <!--color: #124ac1;-->
  <!--}-->
<!--</style>-->



// WEBPACK FOOTER //
// src/views/components/nav-bar/components/search.vue